"use client";

import { c as _c } from "react/compiler-runtime";
import SimpleSearch from "./SimpleSearch";
import Link from "next/link";
import Image from "next/image";
import { sendGTMEvent } from "@next/third-parties/google";
import { ArrowRight } from "lucide-react";
export interface HomeHeroContent {
  headline?: string;
  subheading?: string;
  searchPlaceholder?: string;
  financingTitle?: string;
  financingText?: string;
  financingButtonText?: string;
  sellTitle?: string;
  sellText?: string;
  sellButtonText?: string;
  trustIndicators?: string[];
}
interface HeroVariant5Props {
  className?: string;
  content?: HomeHeroContent | undefined;
}
const DEFAULT_HEADLINE_LINE_1 = "Skip the dealership.";
const DEFAULT_HEADLINE_LINE_2 = "And all the dealershipiness.";
const DEFAULT_SEARCH_PLACEHOLDER = "Search make, model, or type";
export default function HeroVariant5(t0) {
  const $ = _c(20);
  const {
    className: t1,
    content
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const searchPlaceholder = content?.searchPlaceholder || DEFAULT_SEARCH_PLACEHOLDER;
  const isCustomHeadline = Boolean(content?.headline);
  const trackHeroLinkClick = _temp;
  const t2 = `t-w-full ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.trim();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="/imgs/home/home-building-inventory.png" alt="Row of quality used vehicles parked outside the THIScar dealership" fill={true} priority={true} fetchPriority="high" quality={75} sizes="100vw" style={{
      objectPosition: "58% 45%"
    }} className="t-z-[-2] t-object-cover" />;
    t5 = <div className="t-absolute t-inset-0 t-z-[-1] t-bg-[linear-gradient(90deg,rgba(28,29,31,0.9)_0%,rgba(28,29,31,0.78)_40%,rgba(28,29,31,0.38)_72%,rgba(28,29,31,0.18)_100%)]" />;
    t6 = <div className="t-absolute t-inset-x-0 t-bottom-0 t-z-[-1] t-h-2/3 t-bg-gradient-to-t t-from-brand-ink/80 t-to-transparent" />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== content?.headline || $[6] !== isCustomHeadline) {
    t7 = isCustomHeadline ? <h1 id="homepage-hero-heading" className="t-text-4xl t-font-normal t-leading-[1.05] t-tracking-tight t-text-white sm:t-text-5xl lg:t-text-[58px]">{content?.headline}</h1> : <h1 id="homepage-hero-heading" className="t-text-4xl t-font-normal t-leading-[1.05] t-tracking-tight t-text-white sm:t-text-5xl lg:t-text-[58px]"><span className="t-block">{DEFAULT_HEADLINE_LINE_1}</span><span className="t-block t-text-automotive-cta">{DEFAULT_HEADLINE_LINE_2}</span></h1>;
    $[5] = content?.headline;
    $[6] = isCustomHeadline;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== searchPlaceholder) {
    t8 = <div className="t-mt-7 t-max-w-[620px]"><SimpleSearch className="t-w-full" placeholder={searchPlaceholder} showExample={false} /></div>;
    $[8] = searchPlaceholder;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => trackHeroLinkClick("view_all_inventory");
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link href="/cars" onClick={t9} className="t-group t-inline-flex t-items-center t-gap-1.5 t-rounded t-text-white focus:t-outline-none focus:t-ring-2 focus:t-ring-white focus:t-ring-offset-2 focus:t-ring-offset-brand-ink">View all inventory<ArrowRight className="t-h-4 t-w-4 t-transition-transform group-hover:t-translate-x-0.5" aria-hidden="true" /></Link>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => trackHeroLinkClick("shop_by_payment");
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="t-mt-5 t-flex t-flex-wrap t-gap-x-6 t-gap-y-3 t-text-base t-font-extrabold">{t10}<Link href="/cars?modal=payment" onClick={t11} className="t-group t-inline-flex t-items-center t-gap-1.5 t-rounded t-text-white focus:t-outline-none focus:t-ring-2 focus:t-ring-white focus:t-ring-offset-2 focus:t-ring-offset-brand-ink">Shop by payment<ArrowRight className="t-h-4 t-w-4 t-transition-transform group-hover:t-translate-x-0.5" aria-hidden="true" /></Link></div>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t7 || $[15] !== t8) {
    t13 = <section className="t-relative t-isolate t-min-h-[560px] t-overflow-hidden t-bg-brand-ink md:t-min-h-[600px] lg:t-min-h-[660px]" aria-labelledby="homepage-hero-heading">{t4}{t5}{t6}<div className="t-mx-auto t-flex t-min-h-[560px] t-max-w-screen-2xl t-flex-col t-justify-center t-px-4 t-py-14 sm:t-px-6 md:t-min-h-[600px] lg:t-min-h-[660px] lg:t-px-8"><div className="t-w-full">{t7}{t8}{t12}</div></div></section>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t3) {
    t14 = <div className={t3}>{t13}</div>;
    $[17] = t13;
    $[18] = t3;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}
function _temp(linkLabel) {
  ;
  try {
    sendGTMEvent({
      event: "select_content",
      content_type: "hero_link",
      item_id: linkLabel,
      page_section: "hero_section"
    });
  } catch (t0) {
    const error = t0;
    console.error("Analytics tracking error:", error);
  }
}